module.exports = __webpack_public_path__ + "82f60bd0b94a1ed68b1e6e309ce2e8c3.svg";